import { render, staticRenderFns } from "./Sidefix.vue?vue&type=template&id=39c9f4d8&"
import script from "./Sidefix.vue?vue&type=script&lang=js&"
export * from "./Sidefix.vue?vue&type=script&lang=js&"
import style0 from "./Sidefix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports